/**
* @file 业务设置-包车设置
* */
<template>
  <div id="chartered">
    <div class="block">
      <div class="block__left">开通城市</div>
      <div class="block__right">
        <p class="tips" style="margin-bottom: 10px;">添加的城市在小程序包车下单时选择</p>
        <div class="block__right__cityList">
          <el-tag v-for="cityTag in cityTags" :key="cityTag.id" size="medium" closable @close="deleteCity(cityTag)">
            {{ cityTag.city }} </el-tag>
        </div>
        <div class="block__right__cityAdd">
          <el-button type="text" size="medium" @click="cityVisible = true"><i class="el-icon-circle-plus-outline"></i>
            添加城市</el-button>
        </div>
      </div>
    </div>

    <div class="block">
      <div class="block__left">包车套餐</div>
      <div class="block__right">
        <p class="tips">展示给乘客选择</p>
      </div>
    </div>

    <div class="block">
      <div>
        <el-table style="margin-bottom: 20px;width:750px" border empty-text="暂无数据" :data="comboRows">
          <el-table-column label="车型名称" prop="name"></el-table-column>
          <el-table-column label="座位数量" prop="vehicleSeat" width="80" v-slot="{ row }">
            {{ row.vehicleSeat }} 座
          </el-table-column>
          <el-table-column label="基础费用" prop="baseFee" width="80" v-slot="{ row }">
            ￥{{ row.baseFee }}
          </el-table-column>
          <el-table-column label="超时收费" prop="timeFee" width="120" v-slot="{ row }">
            ￥{{ row.timeFee }} / 半小时
          </el-table-column>
          <el-table-column label="超里程费" prop="mileFee" width="120" v-slot="{ row }">
            ￥{{ row.mileFee }} / 公里
          </el-table-column>
          <el-table-column label="车型描述" prop="remark"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template v-slot="{ row }">
              <el-button @click="editComboClick(row)" type="text" size="small">编辑</el-button>
              <el-button type="text" size="small" @click="deleteCombo(row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button style="border: 1px #dcdfe6 dashed;padding: 10px;width: 100%;"
          @click="comboTitle = '创建包车套餐'; comboVisible = true;">
          <i class="el-icon-circle-plus-outline"></i> 添加车型
        </el-button>
      </div>
      <br>
    </div>

    <div class="block">
      <div class="block__left" style="line-height: 28px;">提成规则</div>
      <div class="block__right">
        <el-radio-group v-model="commission.status" :disabled="!commissionEdit">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
        <el-input v-model="commission.proportion" :disabled="!commissionEdit" placeholder="请输入要给司机的提成比例"
          style="width:200px;margin:0 20px" oninput="value=value.replace(/^0/g, '')
    	       					  .replace(/(\d\d{0,1}\.?\d{0,2})?.*/g,'$1')
    	       					  .replace(/^[1-9][0-9]{2,}/g,'100')">
          <template #append>%</template>
        </el-input>
        <el-button v-if="!commissionEdit" type="primary" size="mini" @click="commissionEdit = true">编辑</el-button>
        <div v-else style="display:inline-block">
          <el-button type="primary" size="mini" @click="savecommission">保存</el-button>
          <el-button size="mini" @click="getCommission">取消</el-button>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="cityVisible" @close="checkCity = null" width="20%" title="城市搜索">
      <el-select v-model="checkCity" filterable placeholder="请输入要搜索的城市关键字" style="padding-bottom:20px"
        @change="selectCity">
        <el-option v-for="city in citys" :key="city.cityCode" :label="city.city" :value="city.cityCode">
          <span style="float: left">{{ city.city }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ city.province }}</span>
        </el-option>
      </el-select>
    </el-dialog>

    <el-dialog :visible.sync="comboVisible" @close="$refs.formCombo.resetFields(); formCombo.id = null;" width="25%"
      :title="comboTitle" :close-on-click-modal="false">
      <el-form :model="formCombo" :rules="rulesCombo" ref="formCombo" label-position="left" label-width="80px">
        <el-form-item label="车型名称" prop="name">
          <el-input v-model="formCombo.name" maxlength="8" placeholder="请输入车型名称">
          </el-input>
          <p class="tips">展示给用户看的车型名称</p>
        </el-form-item>
        <el-form-item label="车型描述" prop="remark">
          <el-input v-model="formCombo.remark" maxlength="30" type="textarea" placeholder="建议输入车辆品牌、舒适度、可存放的行李尺寸等">
          </el-input>
        </el-form-item>
        <el-form-item label="座位数量" prop="vehicleSeat">
          <el-select v-model="formCombo.vehicleSeat" filterable>
            <el-option v-for="item in $const.SEATNUMBER" :label="item.label" :key="item.value"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="基础费用" prop="baseFee">
          <el-input v-model="formCombo.baseFee" maxlength="64" placeholder="请输入基础费用"
            oninput="value=value.replace(/[^\d]/g, '')">
            <template slot="append">元</template>
          </el-input>
          <p class="tips">每日基础费用，含每日100公里/8小时</p>
        </el-form-item>
        <el-form-item label="超时收费" prop="timeFee">
          <el-input v-model="formCombo.timeFee" maxlength="64" placeholder="请输入超时长费"
            oninput="value=value.replace(/[^\d]/g, '')">
            <template slot="append">元/半小时</template>
          </el-input>
          <p class="tips">半小时为最小计量单位，超过5分钟按半小时计算/8小时</p>
        </el-form-item>
        <el-form-item label="超里程费" prop="mileFee">
          <el-input v-model="formCombo.mileFee" maxlength="64" placeholder="请输入超里程费"
            oninput="value=value.replace(/[^\d]/g, '')">
            <template slot="append">元/公里</template>
          </el-input>
          <p class="tips">超出部分不足1公里按1公里计算</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="
              text-align: center;
              padding-top: 0;
              position: relative;
              top: -15px;
            ">
        <el-button type="primary" :loading="loadingCombo" @click="saveCombo" style="width:100%">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import provinceCitys from "../../../../public/provinceCitys";

export default {
  name: "chartered",
  data() {
    return {
      cityVisible: false, // 选择城市弹窗显示
      citys: [], // 可选城市列表
      checkCity: null, // 选择的城市
      cityTags: [], // 开通城市列表
      comboRows: [], // 包车套餐列表
      comboVisible: false, // 弹窗显示
      comboTitle: null, // 弹窗标题
      formCombo: { // 套餐对象
        name: null,
        remark: null,
        vehicleSeat: null,
        baseFee: null,
        timeFee: null,
        mileFee: null,
      },
      rulesCombo: { // 套餐对象校验规则
        name: [{ required: true, message: "请输入车型名称" }],
        remark: [{ required: true, message: "请输入车型描述" }],
        vehicleSeat: [{ required: true, message: "请选择座位数量" }],
        baseFee: [{ required: true, message: "请输入基础费用" }],
        timeFee: [{ required: true, message: "请输入超时收费" }],
        mileFee: [{ required: true, message: "请输入超里程费" }],
      },
      loadingCombo: false, // 保存套餐防抖

      commissionEdit: false,
      commission: {
        status: 1,
        proportion: null,
      },
    };
  },
  created() {
    this.getCheckCityList();
    this.getComboList();
    this.getCommission();
    this.getCity();
  },
  mounted() { },
  methods: {
    // 获取已选城市列表
    async getCheckCityList() {
      let data = await this.$axios.get("/api/v1/manage/chartered/city", { organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.cityTags = data.data;
      }
    },

    // 筛选可选城市列表
    getCity() {
      let zhixia = ['北京市', '上海市', '重庆市', '天津市']
      let iteration = (list) => {
        let cityList = [];
        list.map(province => {
          if (zhixia.includes(province.label)) {
            // 直辖市直接返回
            cityList.push({
              province: province.label,
              city: province.label,
              cityCode: province.value
            })
          } else {
            province.children.map(city => {
              cityList.push({
                province: province.label,
                city: city.label,
                cityCode: city.value
              })
            })
          }
        })
        return cityList;
      }

      this.citys = iteration(provinceCitys[0])

    },

    // 添加开通城市
    async selectCity(city) {

      city = this.citys.find(item => item.cityCode == city)
      let data = await this.$axios.post("/api/v1/manage/chartered/city", { ...city, organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.$message.success('已添加')
        this.getCheckCityList();
      }
      this.checkCity = null;
      this.cityVisible = false;
    },

    // 删除一个开通城市
    async deleteCity(city) {
      let data = await this.$axios.delete("/api/v1/manage/chartered/city", { id: city.id });
      if (data && data.code === 1) {
        this.$message.success('已删除')
        this.getCheckCityList();
      }
    },

    // 获取包车套餐列表
    async getComboList() {
      let data = await this.$axios.get("/api/v1/manage/chartered", { organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.comboRows = data.data;
      }
    },

    // 新增/编辑包车套餐 1472123930
    async saveCombo() {
      this.$refs.formCombo.validate(async (valid) => {
        if (valid) {
          let data = null;
          if (this.formCombo.id) {
            data = await this.$axios.put("/api/v1/manage/chartered", { ...this.formCombo, organizationId: this.mixinUserInfo.organizationId });
          } else {
            data = await this.$axios.post("/api/v1/manage/chartered", { ...this.formCombo, organizationId: this.mixinUserInfo.organizationId });
          }
          if (data && data.code === 1) {
            this.$message.success('已保存')
            this.getComboList();
            this.comboVisible = false;
          }
        }
      })
    },

    // 点击套餐编辑
    editComboClick(row) {
      this.comboTitle = "编辑包车套餐";
      this.comboVisible = true;
      this.$nextTick(() => {
        this.formCombo = { ...row };
      })
    },

    // 删除包车套餐
    deleteCombo(id) {
      this.$confirm("删除后乘客端将看不到该套餐，确定删除吗？", "删除提示").then(async () => {
        let data = await this.$axios.delete("/api/v1/manage/chartered", { id });
        if (data && data.code === 1) {
          this.getComboList();
          this.$message.success("删除成功");
        }
      });
    },



    // 获取比例信息
    async getCommission() {
      let data = await this.$axios.get("/api/v1/manage/chartered/commission", { organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.commission = data.data;
      }
      this.commissionEdit = false;
    },

    // 保存比例
    async savecommission() {
      if (this.commission.status == 1 && !this.commission.proportion) {
        this.$message.info("请输入正确的比例");
        return;
      }
      let data = await this.$axios.post("/api/v1/manage/chartered/commission", { ...this.commission, organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.$message.success("已保存");
        this.getCommission();
      }
      this.commissionEdit = false;
    }
  },
};
</script>

<style lang="less">
#chartered {
  .block {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    &__left {
      font-weight: bold;
      width: 100px;
    }

    &__right {
      flex-grow: 1;
    }
  }

  .tips {
    font-size: 14px;
    color: #999;
  }

  .el-tag {
    margin: 0 10px 5px 0;
  }

  .el-input-group__append {
    padding: 0 10px;
  }
}

.el-select-dropdown__wrap {
  max-height: 500px;
}</style>
